// extracted by mini-css-extract-plugin
module.exports = {"wrap":"orderRecordPage_wrap__17ZVh","tableWrap":"orderRecordPage_tableWrap__2pc_Q"};